export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/upToYears.02876c53.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};